<template>
  <el-card class="panel-card" shadow="never">
    <template #header>
      <div class="card-header">
        <span>渠道列表</span>
        <el-tag effect="plain">{{ channels.length }} 个</el-tag>
      </div>
    </template>
    <el-table :data="channels" v-loading="loading" empty-text="暂无渠道" stripe>
      <el-table-column label="名称" min-width="160">
        <template #default="{ row }">
          <el-link v-if="row.official_url" type="primary" :href="row.official_url" target="_blank">
            {{ row.name }}
          </el-link>
          <span v-else>{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Base URL" min-width="240">
        <template #default="{ row }"><span class="mono">{{ row.base_url }}</span></template>
      </el-table-column>
      <el-table-column label="模型" min-width="220">
        <template #default="{ row }">{{ modelSummary(row.models) }}</template>
      </el-table-column>
      <el-table-column label="计费适配器" width="130">
        <template #default="{ row }">{{ adapterLabel(row.billing_adapter) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" />
      <el-table-column prop="weight" label="权重" width="90" />
      <el-table-column label="状态" width="110">
        <template #default="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'" effect="plain">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210" fixed="right">
        <template #default="{ row }">
          <el-button size="small" type="success" plain @click="$emit('test', row)">测试</el-button>
          <el-button size="small" type="primary" plain @click="$emit('edit', row)">编辑</el-button>
          <el-button size="small" type="danger" plain @click="$emit('delete', row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  name: 'ChannelTable',
  props: {
    channels: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit', 'delete', 'test'],
  methods: {
    modelSummary(raw) {
      try {
        const models = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(models) ? models.join(', ') : ''
      } catch (error) {
        return ''
      }
    },
    adapterLabel(adapter) {
      const labels = {
        openai: 'OpenAI 兼容',
        deepseek: 'DeepSeek',
        siliconflow: '硅基流动'
      }
      return labels[adapter] || labels.openai
    }
  }
}
</script>
